module.exports = __webpack_public_path__ + "assets/student-sara.5593db5e.jpg";


//////////////////
// WEBPACK FOOTER
// ../source/assets/homepage/student-sara.jpg
// module id = 1641
// module chunks = 10